import gql from 'graphql-tag';

export const report = gql`
  fragment Report on Report {
    id
    name
    source
    metabaseEmbedPath
    omniContentId
    updatedAt
    createdAt
    workflowTemplateId
  }
`;
